var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-justify"},[_vm._v("\n    "+_vm._s(_vm.$t('card_content'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }